var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 22.3303V22.2142M14.375 22.3303V22.2142M14.375 16.0428V15.9268M20.375 16.0428V15.9268M3.125 9.87138H24.125M5.83929 1V3.31456M21.125 1V3.31427M21.125 3.31427H6.125C3.63972 3.31427 1.625 5.38654 1.625 7.94282V23.3715C1.625 25.9277 3.63972 28 6.125 28H21.125C23.6103 28 25.625 25.9277 25.625 23.3715L25.625 7.94282C25.625 5.38654 23.6103 3.31427 21.125 3.31427Z",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.cac890d8f87ad4d1509aaedab4b9b6b8.svg";
export { ForwardRef as ReactComponent };